import { useSelector } from 'react-redux';
import { getMenusData } from '@Redux/menus/selector';

/**
 * 判斷使用者是否擁有指定 frontKey 的權限（後端回傳的選單資料中有此 frontKey 即有權限）
 * @param {string} frontKey
 * @returns {boolean}
 */
const useHasMenuPermission = (frontKey) => {
    const menus = useSelector(getMenusData);
    return (menus || []).some((menu) => menu.frontKey === frontKey);
};

export default useHasMenuPermission;
